(function(){
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.site-header nav.left');
  if (toggle && nav) {
    toggle.addEventListener('click', function(){
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.querySelector('span').textContent = open ? 'Close' : 'Menu';
    });
  }

  document.querySelectorAll('[data-hero]').forEach(function(hero){
    var slides = hero.querySelectorAll('.slide');
    var dots = hero.querySelectorAll('.dots button');
    if (slides.length < 2) return;
    var i = 0, timer, interval = parseInt(hero.getAttribute('data-interval') || '7000', 10);
    function go(n){
      slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden','true'); if (dots[i]) dots[i].removeAttribute('aria-current');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); slides[i].setAttribute('aria-hidden','false'); if (dots[i]) dots[i].setAttribute('aria-current','true');
    }
    function start(){ if (reduce) return; stop(); timer = setInterval(function(){ go(i+1); }, interval); }
    function stop(){ if (timer) clearInterval(timer); }
    dots.forEach(function(d, n){ d.addEventListener('click', function(){ go(n); start(); }); });
    document.addEventListener('visibilitychange', function(){ document.hidden ? stop() : start(); });
    start();
  });

  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  var form = document.querySelector('form.product-form');
  if (form) {
    var dataEl = document.getElementById('ProductJson');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var btn = form.querySelector('[data-add]');
    var btnText = btn ? btn.querySelector('span') : null;
    var money = function(cents){
      var fmt = document.body.getAttribute('data-money') || '€{{amount_with_comma_separator}}';
      var n = (cents/100).toFixed(2);
      var withComma = n.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var withDot = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace('{{amount_with_comma_separator}}', withComma).replace('{{amount}}', withDot).replace('{{amount_no_decimals}}', Math.round(cents/100));
    };
    function current(){
      var sel = [];
      form.querySelectorAll('fieldset[data-option]').forEach(function(fs){
        var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null);
      });
      return variants.find(function(v){ return v.options.every(function(o, k){ return o === sel[k]; }); });
    }
    function update(){
      var v = current();
      if (!v) { if (btn){ btn.disabled = true; if (btnText) btnText.textContent = 'Unavailable'; } return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) { if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; } else { compareEl.hidden = true; } }
      if (btn) { btn.disabled = !v.available; if (btnText) btnText.textContent = v.available ? 'Add to bag' : 'Sold out'; }
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    form.querySelectorAll('fieldset[data-option] input').forEach(function(inp){ inp.addEventListener('change', update); });
    update();
  }

  document.querySelectorAll('[data-open-details]').forEach(function(b){
    b.addEventListener('click', function(){
      var d = document.getElementById(b.getAttribute('data-open-details'));
      if (d) { d.open = true; d.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
    });
  });

  document.querySelectorAll('.qty').forEach(function(q){
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click', function(){
        var n = parseInt(input.value || '0', 10) + (b.getAttribute('data-dir') === 'up' ? 1 : -1);
        input.value = Math.max(0, n);
        input.form && input.form.submit();
      });
    });
    input && input.addEventListener('change', function(){ input.form && input.form.submit(); });
  });

  var nl = document.querySelector('form.signup');
  if (nl) {
    nl.addEventListener('submit', function(e){
      var c = nl.querySelector('input[type=checkbox]'); var n = nl.parentElement.querySelector('.formnote');
      if (c && !c.checked) { e.preventDefault(); if (n) n.textContent = 'Tick the box so we are allowed to email you.'; c.focus(); }
    });
  }

  var KEY = 'dc_consent_v1', box = document.getElementById('CookieBanner');
  if (box) {
    var ana = document.getElementById('ck-ana'), mkt = document.getElementById('ck-mkt');
    function read(){ try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch(e){ return null; } }
    function write(c){ try { localStorage.setItem(KEY, JSON.stringify(c)); } catch(e){} }
    function setShopify(c){
      try { Shopify.customerPrivacy.setTrackingConsent({ analytics: !!c.analytics, marketing: !!c.marketing, preferences: true, sale_of_data: false }, function(){}); } catch(e){}
    }
    function apply(c){
      document.documentElement.setAttribute('data-consent-analytics', c.analytics ? 'yes' : 'no');
      document.documentElement.setAttribute('data-consent-marketing', c.marketing ? 'yes' : 'no');
      if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) { setShopify(c); }
      else if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(err){ if (!err && Shopify.customerPrivacy) setShopify(c); });
      }
    }
    function show(){ var c = read(); if (c) { ana.checked = !!c.analytics; mkt.checked = !!c.marketing; } box.hidden = false; }
    function done(c){ c.date = new Date().toISOString(); write(c); apply(c); box.hidden = true; }
    box.addEventListener('click', function(e){
      var b = e.target.closest('[data-cookie]'); if (!b) return;
      var k = b.getAttribute('data-cookie');
      if (k === 'accept') done({ necessary:true, analytics:true, marketing:true });
      else if (k === 'reject') done({ necessary:true, analytics:false, marketing:false });
      else if (k === 'save') done({ necessary:true, analytics:ana.checked, marketing:mkt.checked });
    });
    document.querySelectorAll('[data-cookie-open]').forEach(function(el){ el.addEventListener('click', function(){ show(); document.getElementById('ck-details').open = true; }); });
    var existing = read();
    if (existing && existing.date && (Date.now() - Date.parse(existing.date)) < 365*24*3600*1000) { apply(existing); } else { show(); }
  }
})();
